var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['larva_devices'])?_c('router-link',{staticClass:"btn btn-link ml-auto",attrs:{"to":"/app/inventory/devices"}},[_c('fa-icon',{attrs:{"icon":"microchip"}}),_vm._v(" Devices ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }